import { render, staticRenderFns } from "./SearchApp.vue?vue&type=template&id=efb5ee68&"
import script from "./SearchApp.vue?vue&type=script&lang=js&"
export * from "./SearchApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports